<thm-page>
    <ng-template let-title="title" let-menu="menu" let-breadcrumb="breadcrumb"
    let-sidebarNarrow="sidebarNarrow">
        <thm-header>
            <ng-template>
  
                <ng-container *transloco="let t">
                  <div class="navbar-text-area">
                    <thm-header-logo></thm-header-logo>
                  </div>
        
                  <thm-navbar-nav>
                    <thm-nav-item [path]="'/'" [iconClass]="'fas fa-home'">
                      {{ t('header.home') }}
                    </thm-nav-item>
                    <thm-lang-selector></thm-lang-selector>
                    <app-user-panel></app-user-panel>
                  </thm-navbar-nav>
                </ng-container>
        
              </ng-template>
        </thm-header>
        <thm-jumbotron></thm-jumbotron>
        <thm-breadcrumb [data]="breadcrumb"></thm-breadcrumb>
        <thm-main [fluid]="true">
            <thm-sidebar>
                <thm-menu [data]="menu" [narrow]="sidebarNarrow"></thm-menu>
            </thm-sidebar>
            <thm-page-content [title]="title">
                <router-outlet></router-outlet>
            </thm-page-content>
        </thm-main>
        <thm-footer></thm-footer>
    </ng-template>
</thm-page>